<template>
  <div class="popedEmojis" v-if="emojiList">
    <Emoji v-for="(name, index) in emojiList" :key="index" :name="name" />
    <div v-for="(message,index) in chatList" :key="index" :class="['messageBubble',(index!=(chatList.length-1))?'hide':'']">
      {{message}}
    </div>
  </div>
</template>
<script>
import store from "@/store";
import Emoji from "@/components/svg/Emoji";
import config from "@/config";
export default {
  props: {
    playerId: { type: String }
  },
  computed: {
    emojiList: function() {
      if(!store.state.player.playersEmojis[this.playerId])return[];
      return store.state.player.playersEmojis[this.playerId].filter(
        function(message){
          return(config.emojiList.indexOf(message)>=0)
        }
      );
    },
    chatList: function() {
      if(!store.state.player.playersEmojis[this.playerId])return[];
      return store.state.player.playersEmojis[this.playerId].filter(
        function(message){
          return(config.emojiList.indexOf(message)<0)
        }
      );
    }
  },
  components: {
    Emoji
  }
};
</script>
